import Vue from 'vue'

/*
 * En GET, les paramètres de requête passent par `data`, pas par `params` : auth.fetch recompose
 * sa configuration axios à la main et ne recopie pas `params` (voir ExportRepository).
 */

/**
 * La politique de commande d'une organisation : ce qu'on peut y commander, qui valide, les
 * licences, les acomptes, l'usage des données et les badges. Réglages versionnés.
 */
class CommissioningPolicyRepository {

  // GET /api/commissioning/policy-catalogue
  catalogue() {
    return this.fetch({ url: '/api/commissioning/policy-catalogue', method: 'get' })
  }

  // GET /api/commissioning/policies/{organizationId}[?version=] — null tant que rien n'est publié
  get(organizationId, version = null, policyId = null) {
    const params = { ...(version !== null ? { version } : {}), ...(policyId ? { policyId } : {}) }
    return this.fetch({ url: `/api/commissioning/policies/${organizationId}`, method: 'get', data: params })
  }

  // POST /api/commissioning/policies/{organizationId}
  // basedOnVersion : la version chargée par l'écran — un collègue qui a publié entre-temps fait refuser l'envoi.
  publish(organizationId, settings, basedOnVersion, policyId = null) {
    return this.fetch({
      url: `/api/commissioning/policies/${organizationId}` + (policyId ? `?policyId=${policyId}` : ''),
      method: 'post',
      data: { settings, basedOnVersion },
    })
  }

  // GET /api/commissioning/policies/{organizationId}/licence-subscriptions — de quoi licencier un équipement
  licenceSubscriptions(organizationId) {
    return this.fetch({ url: `/api/commissioning/policies/${organizationId}/licence-subscriptions`, method: 'get' })
  }

  // GET /api/commissioning/policies/{organizationId}/vehicle-formulas — les formules véhicule connectables
  // [{ kind, mode, subscriptionId, subscriptionName, formulaId, formulaName, type }]
  vehicleFormulas(organizationId) {
    return this.fetch({ url: `/api/commissioning/policies/${organizationId}/vehicle-formulas`, method: 'get' })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new CommissioningPolicyRepository()
